// extracted by mini-css-extract-plugin
module.exports = {"container":"UserAdminCard_container__1AX6y","column":"UserAdminCard_column__3S94K","button":"UserAdminCard_button__3vhOw"};